import Vue from "vue";
import Vuex from "vuex";

import auth from "./auth.module";
import config from "./config.module";
import living from './living.module';
import page from "./page.module";
import user from "./user.module";
import navigation from "./navigation.module";
import assets from "./assets.module";
import assetLibrary from "./assetLibrary.module";

Vue.use(Vuex);

import { ASSETS_HOST } from "@/common/config";

export default new Vuex.Store({
  state: {
    assetsPath: ASSETS_HOST
  },

  modules: {
    auth,
    config,
    living,
    page,
    user,
    navigation,
    assets,
    assetLibrary
  }
});
